import { matchPath as match } from 'react-router-dom';

export const matchPath = (pathname, path) =>
  !!(
    (typeof path === 'string' && match(pathname, path)) ||
    (Array.isArray(path) && path?.filter(p => match(p, pathname)).length > 0)
  );
